<template>
  <!-- 机构列表 -->
  <div>
    <p class="total">找到{{ total }}条结果</p>
    <van-list
      v-model="loading"
      :finished="finished"
      :error="error"
      :finished-text="List.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="list-box" v-if="loading || List.length > 0">
        <MlItem
          class="list-item"
          v-for="item in List"
          :key="item.id"
          :headerPhoto="item.logo"
          :name="item.title"
          @click.native="toDetail(item.id)"
        />
      </div>
      <noneList noneType="search" v-else />
    </van-list>
  </div>
</template>

<script>
import MlItem from "@/views/mobileView/components/listItem/mlItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  name: "Jg",
  components: { MlItem, noneList },
  data() {
    return {
      userPreferences: {
        pageNo: 0,
        pageSize: 20,
        queryParam: {
          configMap: {
            must: [
              {
                esField: "all",
                queryValue: this.$route.query.paramStr,
              },
              {
                esField: "type",
                queryValue: "5",
              },
            ],
          },
        },
      },
      List: [],
      total: 0,
      loading: false,
      finished: false,
      error: false,
    };
  },
  filters: {
    // 时间格式化
    dateFormat(o) {
      const dt = new Date(Number(o));
      const y = dt.getFullYear();
      const m = (dt.getMonth() + 1 + "").padStart(2, "0");
      const d = (dt.getDate() + "").padStart(2, "0");
      return `${y}-${m}-${d}`;
    },
  },
  methods: {
    // 触底加载
    onLoad() {
      this.userPreferences.pageNo += 1;
      this.user();
    },
    // 搜索用户函数封装
    async user() {
      const resp = await this.$apis.searchServe.userList(this.userPreferences);
      if (resp.resultCode == 200) {
        this.List.push(...resp.data.list);
        this.finished =
          this.userPreferences.pageNo * this.userPreferences.pageSize >=
          resp.data.total;
        this.total = +resp.data.total;
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    // 机构跳转详情
    toDetail(id) {
      this.$router.push({
        path: "/appusesjigou",
        query: {
          item: 2,
          id,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.total {
  text-align: center;
  font-size: 13px;
  color: #999999;
  line-height: 19px;
}
.list-box {
  margin-top: 15px;
  padding: 0 12px;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  .list-item {
    border-bottom: 1px solid #eee;
  }
}
</style>
